import { render, staticRenderFns } from "./dashboard-landing-page.vue?vue&type=template&id=23788f94&scoped=true"
import script from "./dashboard-landing-page.vue?vue&type=script&lang=js"
export * from "./dashboard-landing-page.vue?vue&type=script&lang=js"
import style0 from "./dashboard-landing-page.vue?vue&type=style&index=0&id=23788f94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23788f94",
  null
  
)

export default component.exports